export function isDark(color) {
  const c = color.substring(1); // Strip the #
  const rgb = parseInt(c, 16); // Convert the color to a number
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;
  const brightness = (r * 299 + g * 587 + b * 114) / 1000; // Calculate brightness
  return brightness < 128 // If brightness is less than 128, the color is dark
}
